import React, { useMemo, useState, useEffect } from "react"

import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { axiosbaseurl } from "configure"
import moment from "moment"

import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import Loader from "components/Common/Loader"

const UrgentAttentionReport = () => {
  const [table_data, settable_data] = useState([])
  const [loading, setloading] = useState(false)

  const getAllDueTasks = async () => {
    setloading(true)
    try {
      const response = await axiosbaseurl.get(`/reports/urgent/attention`)
      if (response.data.success) {
        settable_data(response.data.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setloading(false)
    }
  }

  useEffect(() => {
    getAllDueTasks()
  }, [])

  document.title = "Urgent Attention Report | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Urgent Attention Report"}
          />
          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent table_data={table_data} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data }) => {
  const { checkAccess } = usePermissionData()
  const module_id = 24

  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Client Code",
        accessor: "client.clientCode",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Task Name",
        accessor: "title",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Client Name",
        accessor: "client.clientName",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Service",
        accessor: "serviceName.serviceName",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Due Date",
        accessor: "dueDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <span>
              {moment.utc(cellProps.row.original?.dueDate).format("DD/MM/YYYY")}
            </span>
          )
        },
      },
      {
        Header: "Assistant",
        accessor: "assistant",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <span>
              {cellProps.row.original?.assistant
                ? `${cellProps.row.original?.assistant?.name} ${cellProps.row.original?.assistant?.lastName}`
                : "Deleted Employee"}
            </span>
          )
        },
      },
      {
        Header: "Status",
        disableSort: true,
        accessor: "statusName",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          const { colorCode, statusName } = cellProps.row.original?.status
          return (
            <div className="text-center">
              <span
                className="badge text-wrap lh-sm"
                style={{
                  color: colorCode,
                  border: `1px solid ${colorCode}`,
                  fontSize: "11px",
                }}
              >
                {statusName}{" "}
              </span>
            </div>
          )
        },
      },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable
          columns={columns}
          data={data}
          heading={
            <>
              <h5 className="fw-bold text-primary">Urgent Attention Report</h5>
              <h6 className="fw-medium">
                Tasks that are overdue or due within the next 3 months
              </h6>
            </>
          }
        >
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>
      </PermittedComponent>
    </>
  )
}

export default UrgentAttentionReport
